import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboardmain.css";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import axios from "../../axios/axios";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Card, CardBody, Input } from "reactstrap";
import { H4 } from "../../AbstractElements";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdOutlineCancel } from "react-icons/md";
import { GoIssueClosed } from "react-icons/go";
import { IoAlertCircleOutline, IoLockClosedOutline } from "react-icons/io5";
import CountUp from "react-countup";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

const Dashboardmain = () => {
  const navigate = useNavigate();
  const baseurl = useSelector((store) => store.baseUrl);
  const AUTHORIZE_KEY = "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy";
  const componentRef = useRef();
  const image_url_logo = localStorage.getItem("company_logo_pos");
  const [searchtext, setSearchtext] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [filteredinvoiceData, setFilteredInvoiceData] = useState([]);
  const [data_info, setDatainfo] = useState("");
  const [invoiceinfo, setInvoiceinfo] = useState({});
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [topProducts, setTopProducts] = useState([]);
  const [filteredTopProducts, setFilteredTopProducts] = useState([]);
  const [productsInfo, setProductsInfo] = useState("");
  const [selectedView, setSelectedView] = useState("invoice");
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);

  // Product Movement States
  const [productMovementData, setProductMovementData] = useState([]);
  const [filteredProductMovementData, setFilteredProductMovementData] = useState([]);
  const [loadingProductMovement, setLoadingProductMovement] = useState(false);
  const [productMovementInfo, setProductMovementInfo] = useState("");

  // Date Filter States
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleComposeButtonClick = () => {
    navigate(`${process.env.PUBLIC_URL}/dashboardpos`);
  };

  // Format date to required format: "dd-mm-yyyy" (without time)
  const formatDateForAPI = (dateString) => {
    const date = moment(dateString);
    return date.format("DD-MM-YYYY");
  };

  // Get today's date in YYYY-MM-DD format for input
  const getTodayDate = () => {
    return moment().format("YYYY-MM-DD");
  };

  // Set initial dates to today
  const setInitialDates = () => {
    const today = getTodayDate();
    setFromDate(today);
    setToDate(today);
    return {
      start_dt: formatDateForAPI(today),
      end_dt: formatDateForAPI(today)
    };
  };

  // Get current date parameters
  const getDateParams = () => {
    if (fromDate && toDate) {
      return {
        start_dt: formatDateForAPI(fromDate),
        end_dt: formatDateForAPI(toDate)
      };
    }
    return setInitialDates();
  };

  // Get today's date parameters for reset
  const getTodayDateParams = () => {
    const today = getTodayDate();
    return {
      start_dt: formatDateForAPI(today),
      end_dt: formatDateForAPI(today)
    };
  };

  // Number formatting utilities
  const formatNumber = (number, country = 'IN') => {
    if (!number && number !== 0) return '0';

    const num = parseFloat(number);
    if (isNaN(num)) return '0';

    const formatters = {
      'IN': (n) => n.toLocaleString('en-IN'),
      'US': (n) => n.toLocaleString('en-US'),
      'EU': (n) => n.toLocaleString('de-DE'),
      'CN': (n) => n.toLocaleString('zh-CN'),
    };

    const formatter = formatters[country] || formatters['IN'];
    return formatter(num);
  };

  // Calculate total amount for invoicewise sales
  const calculateTotalAmount = (data) => {
    if (!data || data.length === 0) return 0;

    return data.reduce((total, invoice) => {
      const amount = parseFloat(invoice.Amount) || 0;
      return total + amount;
    }, 0);
  };

  // Format currency with symbol and proper formatting
  const formatCurrency = (amount, country = 'IN', currency = 'INR') => {
    const formattedNumber = formatNumber(amount, country);

    const currencySymbols = {
      'INR': '₹',
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'CNY': '¥'
    };

    const symbol = currencySymbols[currency] || currency;

    return `${symbol} ${formattedNumber}`;
  };

  const invoiceColumns = [
    {
      name: "Invoice No.",
      selector: (row) => row?.No,
      sortable: true,
      center: true,
      minWidth: "180px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "180px" }}
          title={row?.No || ""}
        >
          {row?.No || "N/A"}
        </div>
      ),
    },
    {
      name: "Date",
      selector: (row) => row?.Date,
      sortable: true,
      center: true,
      minWidth: "80px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "80px" }}
          title={row?.Date || ""}
        >
          {row?.Date || "N/A"}
        </div>
      ),
    },
    {
      name: "Contacts",
      selector: (row) => row?.Name,
      sortable: true,
      center: true,
      minWidth: "220px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{
            maxWidth: "220px",
            textAlign: "start"
          }}
          title={row?.Name ? row.Name.replace(/\+/g, " ") : "N/A"}
        >
          {row?.Name ? row.Name.replace(/\+/g, " ") : "N/A"}
        </div>
      ),
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.Mobile,
      sortable: true,
      center: true,
      width: "150px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "150px" }}
          title={row?.Mobile || ""}
        >
          {row?.Mobile || "N/A"}
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => row?.Amount,
      sortable: true,
      center: true,
      minWidth: "100px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "100px" }}
          title={`₹ ${row?.Amount || "0"}`}
        >
          {formatCurrency(row?.Amount, 'IN', 'INR')}
        </div>
      ),
    },
    {
      name: "Share",
      cell: (row) => (
        <button
          onClick={() => handleWhatsAppClick(row)}
          disabled={isLoading}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: isLoading
              ? "#ccc"
              : row.create_from == 0
                ? "#FFF"
                : row.create_from == 1
                  ? "#26994e"
                  : "#26994e",
            fontSize: "24px",
          }}
          title="Send via WhatsApp"
          className="text-wrap overflow-hidden"
        >
          <FaWhatsapp />
        </button>
      ),
      center: true,
      minWidth: "80px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const productColumns = [
    {
      name: "Product Code",
      selector: (row) => row.product_code,
      sortable: true,
      center: true,
      minWidth: "150px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "150px" }}
          title={row?.product_code || ""}
        >
          {row?.product_code || "N/A"}
        </div>
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
      center: true,
      minWidth: "200px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "200px", textAlign: "start" }}
          title={row?.product_name || ""}
        >
          {row?.product_name || "N/A"}
        </div>
      ),
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
      minWidth: "100px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "100px" }}
          title={row?.quantity || "0"}
        >
          {row?.quantity || "0"}
        </div>
      ),
    },
  ];

  // Product Movement Columns
  const productMovementColumns = [
    {
      name: "Product Code",
      selector: (row) => row.product_code,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "120px" }}
          title={row?.product_code || ""}
        >
          {row?.product_code || "N/A"}
        </div>
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
      center: true,
      minWidth: "200px",
      cell: (row) => (
        <div
          className="text-wrap overflow-hidden"
          style={{ maxWidth: "200px", textAlign: "start" }}
          title={row?.product_name || ""}
        >
          {row?.product_name || "N/A"}
        </div>
      ),
    },
    {
      name: "Inward Quantity",
      selector: (row) => row.inward_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#28a745", fontWeight: "bold" }}>
          {row.inward_qty}
        </span>
      ),
    },
    {
      name: "Outward Quantity",
      selector: (row) => row.outward_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#dc3545", fontWeight: "bold" }}>
          {row.outward_qty}
        </span>
      ),
    },
    {
      name: "Balance Quantity",
      selector: (row) => row.remaining_qty,
      sortable: true,
      center: true,
      minWidth: "120px",
      cell: (row) => (
        <span style={{ color: "#007bff", fontWeight: "bold" }}>
          {row.remaining_qty}
        </span>
      ),
    },
  ];

  //Added by Akshar for Background Color for TR
  // Define conditional row styles
  const conditionalRowStyles = [
    {
      when: (row) => row.create_from == 0, // Condition for create_from: 0
      style: {
        backgroundColor: "#007c41 !important", // Light red background
        color: "#fff !important", // Darker text color for contrast
      },
    },
    {
      when: (row) => row.create_from == 1, // Condition for create_from: 1
      style: {
        backgroundColor: "#f5f4ef !important", // Light green background
        color: "#098048 !important", // Darker text color for contrast
      },
    },
  ];

  // Format API response to match template structure
  const formatInvoiceData = (apiData) => ({
    ...apiData,
    Invoice_fullno: apiData.fullinvoiceno,
    contact_name: apiData.contact_name,
    contact_number: apiData.mobile_no,
    currenttodaydate: apiData.invoice_dt,
    cart: apiData.products.map((product) => ({
      product_id: product.id || Math.random().toString(36).substr(2, 9),
      name: product.name,
      quantity: product.quantity,
      subT: product.price * product.quantity,
      price: product.price,
      // primary_unit: product.primary_unit,
      // secondary_unit: product.secondary_unit,
      // conversion_flg: product.conversion_flg,
    })),
    billSummary: {
      actualTotalPrice: apiData.total_amount,
      totalDiscount: apiData.total_discount,
      totalTaxes: apiData.total_tax,
      grandTotal: apiData.grand_total,
    },
  });

  // Fetch invoice data from API
  const fetchInvoiceData = async (invoiceId) => {
    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("invoice_id", invoiceId);

      const response = await fetch(
        `${baseurl}/expo_access_api/getInvoiceProductData/`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result?.STATUS === "SUCCESS" && result?.DATA) {
        return formatInvoiceData(result?.DATA);
      }
      throw new Error("Failed to fetch invoice data");
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  };

  // Handle WhatsApp click
  const handleWhatsAppClick = async (row) => {
    try {
      setIsLoading(true);
      const data = await fetchInvoiceData(row?.ID);
      await generatePDF(data);
    } catch (error) {
      toast.error(error.message || "Error processing invoice", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Generate PDF and send to WhatsApp (now accepts invoiceData parameter)
  const generatePDF = async (invoiceData) => {
    if (!invoiceData) return;

    let originalStyles = {};

    try {
      setIsLoading(true);
      window.html2canvas = html2canvas;

      setCurrentInvoice(invoiceData);

      const element = document.querySelector("#rep1");

      originalStyles = {
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        visibility: element.style.visibility,
      };

      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.visibility = "visible";

      await new Promise((resolve) => setTimeout(resolve, 150));

      const pdf = new jsPDF("p", "mm", "a4");

      const canvas = await html2canvas(element, {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight, undefined, "FAST");

      const blobPDF = new Blob([pdf.output("blob")], {
        type: "application/pdf",
      });

      await sendPDFToWhatsApp(blobPDF, invoiceData);
      setCurrentInvoice(null);
    } catch (error) {
      console.error("PDF generation error:", error);
      toast.error("Error generating PDF", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      const element = document.querySelector("#rep1");
      if (element) {
        element.style.position = originalStyles.position || "";
        element.style.left = originalStyles.left || "";
        element.style.top = originalStyles.top || "";
        element.style.visibility = originalStyles.visibility || "hidden";
      }
      setIsLoading(false);
    }
  };

  // Send PDF to WhatsApp API (now accepts invoiceData parameter)
  const sendPDFToWhatsApp = async (pdfBlob, invoiceData) => {
    try {
      const message = `Hi ${invoiceData.contact_name}, Attached is your invoice. Let me know if you need anything else.`;
      const formData = new FormData();
      formData.append("image", pdfBlob);
      formData.append("invoice_id", invoiceData.invoice_id);
      formData.append("contact_id", invoiceData.contact_id);
      formData.append("countrycode", 91);
      formData.append("mobileno", invoiceData.contact_number);
      formData.append("wp_clientmsg", message);
      formData.append("contactType", invoiceData.type);
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));

      const response = await fetch(
        `${baseurl}/expo_access_api/invoicePdfsendfdtowhatsapp/`,
        { method: "POST", body: formData }
      );

      if (!response.ok) throw new Error("Failed to send PDF");

      toast.success("Invoice sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error("WhatsApp send error:", error);
      throw error;
    }
  };

  // Fetch Top Products with date filter using FormData
  const fetchTopProducts = async (dateParams = null) => {
    setLoadingProducts(true);
    try {
      const params = dateParams || getDateParams();

      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("start_dt", params.start_dt);
      formData.append("end_dt", params.end_dt);

      const res = await axios.post("/ecommerce_api/getSellingTopProducts", formData);

      const { data } = res;

      if (data && data?.STATUS === "SUCCESS" && data?.DATA) {
        setTopProducts(data.DATA);
        setFilteredTopProducts(data.DATA);
        setProductsInfo("");
      } else {
        setProductsInfo(data?.MSG || "Data Not Found");
        setTopProducts([]);
        setFilteredTopProducts([]);
      }
    } catch (error) {
      console.error("Error fetching top products:", error);
      setProductsInfo("Data Not Found");
      setTopProducts([]);
      setFilteredTopProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  // Fetch Transaction List with date filter
  const fetchTransactionList = async (dateParams = null) => {
    setLoadingInvoices(true);
    try {
      const params = dateParams || getDateParams();

      const res = await axios.post("/expo_access_api/getTransactionList", {
        AUTHORIZEKEY: process.env.REACT_APP_AUTHORIZE_KEY,
        start_dt: params.start_dt,
        end_dt: params.end_dt
      });

      const { data } = res;

      if (data && data[0]?.DATA?.invoiceList) {
        const message = data[0].MSG;
        setDatainfo(message);
        setInvoiceData(res?.data[0]?.DATA?.invoiceList);
        setFilteredInvoiceData(res?.data[0]?.DATA?.invoiceList);
        setInvoiceinfo(res?.data[0]?.DATA);
      } else {
        const message = data[0].MSG;
        setDatainfo(message);
        setInvoiceData([]);
        setFilteredInvoiceData([]);
        setInvoiceinfo({});
      }
    } catch (error) {
      console.error("Error fetching transaction list:", error);
      setDatainfo("Data Not Found");
      setInvoiceData([]);
      setFilteredInvoiceData([]);
      setInvoiceinfo({});
    } finally {
      setLoadingInvoices(false);
    }
  };

  // Fetch Product Movement Data with date filter
  const fetchProductMovement = async (dateParams = null) => {
    setLoadingProductMovement(true);
    try {
      const params = dateParams || getDateParams();

      const res = await axios.post("/ecommerce_api/getProductMovement", {
        AUTHORIZEKEY: process.env.REACT_APP_AUTHORIZE_KEY,
        start_dt: params.start_dt,
        end_dt: params.end_dt
      });

      const { data } = res;

      if (data && data?.STATUS === "SUCCESS" && data?.DATA) {
        const formattedData = data.DATA.map(item => ({
          ...item,
          inward_qty: item.inward_qty,
          outward_qty: item.outward_qty,
          remaining_qty: item.remaining_qty
        }));

        setProductMovementData(formattedData);
        setFilteredProductMovementData(formattedData);
        setProductMovementInfo("");
      } else {
        setProductMovementInfo(data?.MSG || "Data Not Found");
        setProductMovementData([]);
        setFilteredProductMovementData([]);
      }
    } catch (error) {
      console.error("Error fetching product movement:", error);
      setProductMovementInfo("Data Not Found");
      setProductMovementData([]);
      setFilteredProductMovementData([]);
    } finally {
      setLoadingProductMovement(false);
    }
  };

  // Handle Search button click
  const handleSearch = () => {
    const dateParams = getDateParams();

    switch (selectedView) {
      case "invoice":
        fetchTransactionList(dateParams);
        break;
      case "products":
        fetchTopProducts(dateParams);
        break;
      case "movement":
        fetchProductMovement(dateParams);
        break;
      default:
        break;
    }
  };

  // Handle Reset button click
  const handleReset = () => {
    const today = getTodayDate();
    setFromDate(today);
    setToDate(today);
    setSearchtext("");

    const todayDateParams = getTodayDateParams();

    switch (selectedView) {
      case "invoice":
        fetchTransactionList(todayDateParams);
        break;
      case "products":
        fetchTopProducts(todayDateParams);
        break;
      case "movement":
        fetchProductMovement(todayDateParams);
        break;
      default:
        break;
    }
  };

  // Handle view change
  const handleViewChange = (e) => {
    const newView = e.target.value;
    setSelectedView(newView);
    setSearchtext("");

    const dateParams = getDateParams();

    switch (newView) {
      case "invoice":
        fetchTransactionList(dateParams);
        break;
      case "products":
        fetchTopProducts(dateParams);
        break;
      case "movement":
        fetchProductMovement(dateParams);
        break;
      default:
        break;
    }
  };

  // Handle text search
  const handleTextSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchtext(searchValue);

    const filterData = (data) => {
      return data.filter((item) => {
        return Object.keys(item).some((key) => {
          if (item[key] && typeof item[key] === "string") {
            const cleanedItem = item[key]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "")
              .replace(/\s+/g, " ")
              .trim();
            const cleanedSearchValue = searchValue
              .replace(/[^a-z0-9]+/g, "")
              .replace(/\s+/g, " ")
              .trim();

            return cleanedItem.includes(cleanedSearchValue);
          }
          return false;
        });
      });
    };

    if (selectedView === "invoice") {
      const filteredItems = filterData(invoiceData);
      setFilteredInvoiceData(filteredItems);
    } else if (selectedView === "products") {
      const filteredItems = filterData(topProducts);
      setFilteredTopProducts(filteredItems);
    } else if (selectedView === "movement") {
      const filteredItems = filterData(productMovementData);
      setFilteredProductMovementData(filteredItems);
    }
  };

  // Initialize component
  useEffect(() => {
    setInitialDates();
    const todayDateParams = getTodayDateParams();
    fetchTransactionList(todayDateParams);
  }, []);

  return (
    <>
      <div className="dashboardposmain">
        <div className="grid-container-dashboard ">
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round primary`}>
                    <div className="bg-round">
                      <LiaFileInvoiceSolid color="#7366ff" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.total_invoice}
                      />
                    </H4>
                    <span className="f-light">Invoice</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round warning`}>
                    <div className="bg-round">
                      <MdOutlineCancel color="#ffaa05" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.cancel_invoice}
                      />
                    </H4>
                    <span className="f-light">Cancel Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round secondary`}>
                    <div className="bg-round">
                      <IoLockClosedOutline color="#d63384" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.close_invoice}
                      />
                    </H4>
                    <span className="f-light">Close Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card className="widget-1">
              <CardBody>
                <div className="widget-content">
                  <div className={`widget-round success`}>
                    <div className="bg-round">
                      <GoIssueClosed color="#54ba4a" />
                    </div>
                  </div>
                  <div>
                    <H4>
                      <CountUp
                        prefix=""
                        duration={3}
                        start={0}
                        separator=","
                        end={invoiceinfo?.paid_invoice}
                      />
                    </H4>
                    <span className="f-light">Paid Orders</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>

        <Row>
          <Col sm="12">
            <Card>
              {isLoading && (
                <div className="text-center timesheet-label mt-3">
                  Please wait while sending the invoice...
                </div>
              )}
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div style={{ width: '200px' }}></div>
                  <div className="export-new">
                    <Button
                      className="searchbtn"
                      onClick={handleComposeButtonClick}
                    >
                      Create Invoice
                    </Button>
                  </div>
                </div>

                <div className="my-2">
                  {/* Date Filter Section - Centered */}
                  <div className="row mb-3 align-items-end justify-content-center">
                    <div className="col-md-4 col-sm-6">
                      <label htmlFor="fromDate" className="form-label fw-bold">From Date</label>
                      <Input
                        type="date"
                        id="fromDate"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <label htmlFor="toDate" className="form-label fw-bold">To Date</label>
                      <Input
                        type="date"
                        id="toDate"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        min={fromDate}
                      />
                    </div>
                  </div>

                  {/* Search and Reset Buttons Row - Centered */}
                  <div className="row mb-3 align-items-end justify-content-center">
                    <div className="col-md-4">
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          className="searchbtn"
                          onClick={handleSearch}
                          disabled={loadingInvoices || loadingProducts || loadingProductMovement}
                          style={{ minWidth: '120px' }}
                        >
                          Search
                        </Button>
                        <Button
                          variant="outline-secondary"
                          onClick={handleReset}
                          disabled={loadingInvoices || loadingProducts || loadingProductMovement}
                          style={{ minWidth: '120px' }}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* Search and View Type Section - Justify between */}
                  <div className="row mb-3 align-items-end justify-content-between">
                    <div className="col-md-6">
                      <Input
                        id="searchText"
                        className="form-control register-full input-register"
                        type="text"
                        placeholder="Search across all fields..."
                        value={searchtext}
                        onChange={handleTextSearch}
                      />
                    </div>
                    <div className="col-md-3">
                      <Input
                        type="select"
                        id="viewSelect"
                        value={selectedView}
                        onChange={handleViewChange}
                        className="form-control register-full input-register"
                      >
                        <option value="invoice">Invoicewise Sales</option>
                        <option value="products">Productwise Sales</option>
                        <option value="movement">Product Movement</option>
                      </Input>
                    </div>
                  </div>

                  {selectedView === "invoice" ? (
                    loadingInvoices ? (
                      <div className="text-center mt-3">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : data_info === "Data Not Found" || invoiceData.length === 0 ? (
                      <div
                        className="text-center mt-3 py-3"
                        style={{ backgroundColor: "#dfdcdc" }}
                      >
                        No Records found
                      </div>
                    ) : (
                      <>
                        <DataTable
                          data={filteredinvoiceData}
                          columns={invoiceColumns}
                          striped={true}
                          center={true}
                          pagination
                          conditionalRowStyles={conditionalRowStyles}
                          className="pos-dashboard-table"
                        />

                        {/* Total Amount Display Section */}
                        <div className="total-amount-section mt-3 p-3" style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px"
                        }}>
                          <div className="row justify-content-end">
                            <div className="col-md-4">
                              <div className="d-flex justify-content-between align-items-center">
                                <strong className="text-dark">Total Amount:</strong>
                                <strong className="text-success" style={{ fontSize: "1.2rem" }}>
                                  {formatCurrency(calculateTotalAmount(filteredinvoiceData), 'IN', 'INR')}
                                </strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  ) : selectedView === "products" ? (
                    loadingProducts ? (
                      <div className="text-center mt-3">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : productsInfo === "Data Not Found" || topProducts.length === 0 ? (
                      <div
                        className="text-center mt-3 py-3"
                        style={{ backgroundColor: "#dfdcdc" }}
                      >
                        No Records found
                      </div>
                    ) : (
                      <DataTable
                        data={filteredTopProducts}
                        columns={productColumns}
                        striped={true}
                        center={true}
                        pagination
                        className="pos-dashboard-table"
                      />
                    )
                  ) : (
                    // Product Movement View
                    loadingProductMovement ? (
                      <div className="text-center mt-3">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : productMovementInfo === "Data Not Found" || productMovementData.length === 0 ? (
                      <div
                        className="text-center mt-3 py-3"
                        style={{ backgroundColor: "#dfdcdc" }}
                      >
                        No Records found
                      </div>
                    ) : (
                      <DataTable
                        data={filteredProductMovementData}
                        columns={productMovementColumns}
                        striped={true}
                        center={true}
                        pagination
                        className="pos-dashboard-table"
                      />
                    )
                  )}
                </div>
              </CardBody>
              {isLoading && (
                <div className="text-center timesheet-label mb-3">
                  Please wait while sending the invoice...
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      {/* Hidden invoice template */}
      <div>
        <div
          className="d-flex justify-content-center align-items-center"
          ref={componentRef}
          id="rep1"
          style={{
            width: "210mm",
            minHeight: "auto",
            padding: "20px",
            backgroundColor: "white",
            boxSizing: "border-box",
            visibility: "hidden",
            position: "absolute",
          }}
        >
          <div className="receipt" style={{ width: "100%", height: "100%" }}>
            <div className="text-center">
              <img
                src={`${baseurl}${image_url_logo}`}
                alt="Company Logo"
                className="img-fluid for-light my-2"
              />
            </div>

            <p>
              <b>Name:</b> {currentInvoice?.contact_name || "Cash Contact"}
            </p>
            <p>
              <b>Mobile:</b> {currentInvoice?.contact_number || "9824023886"}
            </p>
            <hr className="my-2" />
            <p>
              <b>Invoice No:</b> {currentInvoice?.Invoice_fullno}
            </p>
            <p>
              <b>Date:</b> {currentInvoice?.currenttodaydate}
            </p>
            <hr className="my-2" />

            <table className="invoice-products">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {currentInvoice?.cart?.map((item) => (
                  <tr key={item?.product_id || Math.random()}>
                    <td>{item?.name}</td>
                    {/* <td>
                      {item.conversion_flg == "1"
                        ? item.primary_unit
                          ? `${item.quantity} (${item.primary_unit})`
                          : item.quantity
                        : item.secondary_unit
                          ? `${item.quantity} (${item.secondary_unit})`
                          : item.quantity
                      }
                    </td> */}
                    <td>{item?.quantity}</td>
                    <td>
                      <span className="inr-font">INR </span>
                      {item?.price?.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="2">Total Gross Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.actualTotalPrice}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Discount Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.totalDiscount}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Taxes Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.totalTaxes}
                  </td>
                </tr>
                <tr>
                  <th colSpan="2">Total Payable Amount</th>
                  <td>
                    <span className="inr-font">INR </span>
                    {currentInvoice?.billSummary?.grandTotal?.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>

            <hr className="my-2" />
            <p>Thank you for your business!</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboardmain;